import { Injectable } from '@angular/core'
import { Functions, httpsCallable } from '@angular/fire/functions'
import { ApiTokenListItem, CreateApiTokenRequest, CreateApiTokenResponse } from '@parkupp/core'
import { environment } from '../../environments/environment'

@Injectable({
    providedIn: 'root',
})
export class EnterpriseApiService {
    constructor(private functions: Functions) {}

    /**
     * Get the base URL for the API documentation
     * Note: Trailing slash is required to prevent redirect issues with swagger-ui-express
     */
    getApiDocsUrl(enterpriseKey: string): string {
        if (environment.production) {
            return 'https://us-central1-parkupp-production.cloudfunctions.net/api/docs/'
        }
        // Local development
        return 'http://localhost:5004/parkupp-production/us-central1/api/docs/'
    }

    /**
     * Create a new API token
     */
    async createToken(request: CreateApiTokenRequest): Promise<CreateApiTokenResponse> {
        try {
            const callable = httpsCallable(this.functions, 'enterpriseApi-createToken', {
                timeout: 30000,
            })
            const result = await callable(request)
            return result.data as CreateApiTokenResponse
        } catch (error: any) {
            console.error('[EnterpriseAPI] Error creating token:', error)
            throw error
        }
    }

    /**
     * List all API tokens for an enterprise
     */
    async listTokens(enterpriseKey: string): Promise<ApiTokenListItem[]> {
        try {
            const callable = httpsCallable(this.functions, 'enterpriseApi-listTokens', {
                timeout: 30000,
            })
            const result = await callable({ enterpriseKey })
            const data = result.data as { success: boolean; tokens: ApiTokenListItem[] }
            return data.tokens || []
        } catch (error: any) {
            console.error('[EnterpriseAPI] Error listing tokens:', error)
            throw error
        }
    }

    /**
     * Revoke an API token
     */
    async revokeToken(enterpriseKey: string, tokenKey: string): Promise<{ success: boolean; error?: string }> {
        try {
            const callable = httpsCallable(this.functions, 'enterpriseApi-revokeToken', {
                timeout: 30000,
            })
            const result = await callable({ enterpriseKey, tokenKey })
            return result.data as { success: boolean; error?: string }
        } catch (error: any) {
            console.error('[EnterpriseAPI] Error revoking token:', error)
            throw error
        }
    }
}
